import { useState } from 'react';
import { FlexCenter, Table } from '@elementary/common-ui/components';
import useAccountPermission from '@elementary/common-ui/hooks/useAccountPermission';
import { Typography } from '@mui/material';
import SettingsSection from '../SettingsSection';
import { Runtime } from '../types';
import useRuntimeConnectionsColumns from '../hooks/useRuntimeConnectionsColumns';
import AddWarehousesDialog from './AddWarehousesDialog';

type Props = {
  runtime: Runtime;
};

const RuntimeWarehouses = ({ runtime }: Props) => {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const hasAccountPermission = useAccountPermission();
  const columns = useRuntimeConnectionsColumns(runtime);

  return (
    <SettingsSection
      title="Warehouses"
      actionLabel={
        hasAccountPermission('EDIT_RUNTIMES') ? 'Add warehouse' : undefined
      }
      onAction={() => setIsAddDialogOpen(true)}
    >
      <Table
        data={runtime.connections}
        columns={columns}
        urlParamsPrefix="runtime_warehouses_table"
        emptyStateRenderer={() => (
          <FlexCenter sx={{ width: '100%', py: 2 }}>
            <Typography sx={{ color: 'common.gray11' }}>
              No warehouses yet. Add the warehouses this runtime should run
              queries on.
            </Typography>
          </FlexCenter>
        )}
      />

      <AddWarehousesDialog
        isOpen={isAddDialogOpen}
        onClose={() => setIsAddDialogOpen(false)}
        runtime={runtime}
      />
    </SettingsSection>
  );
};

export default RuntimeWarehouses;
